import React, { useEffect, useState } from "react";
import MobileLayout from "../components/layout/MobileLayout";
import PageHeader from "../components/PageHeader";
import { api } from "../lib/api";
import { Gift, Crown } from "lucide-react";

export default function BonusHistory() {
  const [data, setData] = useState({ items: [], total_earned: 0, count: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/wallet/bonus-history")
      .then((r) => setData(r.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <MobileLayout>
      <PageHeader title="Bonus History" testId="bonus-history-header" />
      <div className="px-3 pb-6">
        {/* Total earned hero */}
        <div className="relative rounded-2xl bg-gradient-to-br from-yellow-400 via-amber-500 to-orange-600 border-2 border-yellow-200 shadow-2xl p-5 text-center overflow-hidden mb-3" data-testid="bonus-total-hero">
          <div className="absolute inset-0 pattern-grid opacity-20" />
          <div className="absolute -top-6 -right-6 w-24 h-24 bg-white/30 rounded-full blur-2xl" />
          <div className="relative">
            <div className="inline-flex items-center gap-1.5 bg-blue-950 text-yellow-300 px-3 py-1 rounded-full text-[10px] font-black tracking-widest mb-2">
              <Gift className="w-3 h-3" /> LIFETIME BONUS
            </div>
            <div className="font-display font-black text-5xl text-white tracking-tight drop-shadow-lg tabular-nums">
              ₹{Number(data.total_earned || 0).toLocaleString("en-IN")}
            </div>
            <div className="text-xs text-blue-950 font-bold mt-1 tracking-wider">{data.count} bonus credits</div>
          </div>
        </div>

        {/* List */}
        {loading ? (
          <div className="text-center text-cyan-200/60 py-10">Loading…</div>
        ) : data.items.length === 0 ? (
          <div className="rounded-2xl p-10 text-center shadow-xl backdrop-blur-sm"
            style={{
              background: "linear-gradient(180deg, rgba(10,24,51,0.65) 0%, rgba(6,14,40,0.9) 100%)",
              border: "1px solid rgba(34,211,238,0.25)",
            }}>
            <Gift className="w-10 h-10 mx-auto mb-2 text-cyan-300/60" />
            <div className="text-cyan-100 text-sm">Abhi tak koi bonus nahi mila</div>
            <div className="text-cyan-200/60 text-xs mt-1">Reddy code share karo aur bonus kamao</div>
          </div>
        ) : (
          <div className="space-y-2" data-testid="bonus-list">
            {data.items.map((t) => {
              const positive = Number(t.amount || 0) > 0;
              const label = labelFor(t);
              return (
                <div
                  key={t.id}
                  data-testid={`bonus-row-${t.id}`}
                  className="relative rounded-xl p-3 shadow-lg flex items-center gap-3 backdrop-blur-sm"
                  style={{
                    background: "linear-gradient(180deg, rgba(10,24,51,0.65) 0%, rgba(6,14,40,0.9) 100%)",
                    border: "1px solid rgba(251,191,36,0.35)",
                  }}
                >
                  <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-yellow-400 to-amber-600 text-blue-950 flex items-center justify-center shadow shrink-0">
                    <Gift className="w-5 h-5" strokeWidth={2.5} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="font-bold text-white text-sm truncate">{label}</div>
                    <div className="text-[11px] text-cyan-200/70">
                      {new Date(t.created_at).toLocaleDateString("en-IN", {
                        day: "2-digit", month: "short", year: "numeric",
                      })} · {new Date(t.created_at).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })}
                    </div>
                    {t.note && <div className="text-[10px] text-cyan-200/60 mt-0.5 italic truncate">{t.note}</div>}
                  </div>
                  <div className={`font-black text-base tabular-nums shrink-0 ${positive ? "text-emerald-300" : "text-rose-300"}`}>
                    {positive ? "+" : ""}₹{Math.abs(Number(t.amount || 0)).toLocaleString("en-IN")}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </MobileLayout>
  );
}

function labelFor(t) {
  const type = (t.type || "").toLowerCase();
  if (type === "referral_bonus") return "Reddy Referral Bonus";
  if (type === "welcome_bonus")  return "Welcome Bonus";
  if (type === "admin_credit")   return "Admin Credit";
  if (type === "bonus")          return "Bonus";
  if ((t.note || "").toLowerCase().includes("refer")) return "Reddy Referral Bonus";
  return "Bonus";
}
